const DIALOG_TYPES = {
    "PRIMARY": "primary",
    "SECONDARY": "secondary",
    "SUCCESS": "success",
    "WARNING": 'warning',
    "ALERT": "alert",
    "DEFAULT": 'default',
  };
export default  DIALOG_TYPES;